export const WARRANTY_LENGTH_OPTIONS = [
  { id: 1, value: 0, label: 'No Warranty' },
  { id: 2, value: 30, label: '30 Days' },
  { id: 3, value: 60, label: '60 Days' },
  { id: 4, value: 90, label: '90 Days' },
  { id: 5, value: 180, label: '180 Days' },
  { id: 6, value: 365, label: '1 Year' },
];
